import Vue from 'vue'
import Router from 'vue-router'
import fxViewComponent from '@/components/fxView'
//-------------------------request_access----------------------------------------------------------------
const request_access = () => import('@/components/fxView/request/request_access')
//-------------------------coupon----------------------------------------------------------------
const couponListing = () => import('@/components/fxView/coupon/coupon_listing')
const createCoupon = () => import('@/components/fxView/coupon/create_coupon')

//-------------------------admin----------------------------------------------------------------
const adminListing = () => import('@/components/fxView/admin/admin_listing')
const adminView = () => import('@/components/fxView/admin/admin_view')
const adminAdd = () => import('@/components/fxView/admin/create_admin')
//-------------------------client----------------------------------------------------------------
const createClient = () => import('@/components/fxView/client/create_client')
const clientListing = () => import('@/components/fxView/client/client_listing')
const clientView = () => import('@/components/fxView/client/client_view')
//-------------------------admin-----------------------------------------------------------------
const change_password = () => import('@/components/fxView/admin/change_password')
const adminLogin = () => import('@/components/fxView/admin/login')
const adminDashboard = () => import('@/components/fxView/admin/dashboard')
//-------------------------ticket-----------------------------------------------------------------
const createTicket = () => import('@/components/fxView/ticket/create_ticket')
const ticketListing = () => import('@/components/fxView/ticket/ticket_list')
const ticketView = () => import('@/components/fxView/ticket/ticket_view')
//-------------------------deposit---------------------------------------------------------------
const depositListing = () => import('@/components/fxView/deposit/deposit_listing')
const depositTransaction = () => import('@/components/fxView/deposit/deposit_transaction')
const depositView = () => import('@/components/fxView/deposit/deposit_view')
const createDeposit = () => import('@/components/fxView/deposit/create_deposit')
//-------------------------Wallet---------------------------------------------------------------
const walletListing = () => import('@/components/fxView/wallet/wallet_listing')

//-------------------------bonus---------------------------------------------------------------
const createBonus = () => import('@/components/fxView/bonus/create_bonus')
const bonusListing = () => import('@/components/fxView/bonus/bonus_listing')
const bonusView = () => import('@/components/fxView/bonus/bonus_view')
//-------------------------commission---------------------------------------------------------------
const commissionListing = () => import('@/components/fxView/commission/commission_listing')
const commissionView = () => import('@/components/fxView/commission/commission_view')
const createCommission = () => import('@/components/fxView/commission/create_commission')
//-------------------------withdrawal------------------------------------------------------------
const createWithdrawal = () => import('@/components/fxView/withdrawal/create_withdrawal')
const withdrawalListing = () => import('@/components/fxView/withdrawal/withdrawal_listing')
const withdrawalView = () => import('@/components/fxView/withdrawal/withdrawal_view')
//-------------------------trading-account-------------------------------------------------------
const createTrading = () => import('@/components/fxView/trading/create_trading')
const tradingListing = () => import('@/components/fxView/trading/trading_listing')
const tradingChangeStatus = () => import('@/components/fxView/trading/trading_changestatus')
const tradingView = () => import('@/components/fxView/trading/trading_view')
//-------------------------search-list-------------------------------------------------------
const search = () => import('@/components/fxView/shared/search')

//-------------------------Contact details-------------------------------------------------------
const contactDetails = () => import('@/components/fxView/contact/contact_details')

const notificationListing = () => import('@/components/fxView/admin/notification_listing')

Vue.use(Router)
export default new Router({
	mode: 'history',
	routes: [
		//-------------------------admin-login--------------------------------------------------
		{ path: '/', name: 'admin.adminLogin', component: adminLogin },
		{
			path:'/',
			component: fxViewComponent,
			children:[
				{ path: '/change-password', name: 'account.change_password', component: change_password },
				//-------------------------reporting------------------------------------------------
				{ path: '/request-access', name: 'request.request_access',  component: request_access },
				//-------------------------reporting------------------------------------------------
				{ path: '/coupon-listing', name: 'coupon.couponListing',  component: couponListing },
				{ path: '/create-coupon', name: 'coupon.createCoupon',  component: createCoupon },
				
				//-------------------------admin------------------------------------------------
				{ path: '/admin-list', name: 'admin.adminListing',  component: adminListing },
				{ path: '/admin-view',  name: 'admin.adminView', props : true, component: adminView },
				{ path: '/create-admin',  name: 'admin.adminAdd', props : true, component: adminAdd },
				//-------------------------client------------------------------------------------
				{ path: '/create-client', name: 'client.createClient',  component: createClient },
				{ path: '/listing', name: 'client.clientListing',  component: clientListing },
				{ path: '/view',  name: 'client.clientView', props : true, component: clientView },
				//-------------------------ticket------------------------------------------------
				{ path: '/create-ticket', name: 'ticket.createTicket',  component: createTicket },
				{ path: '/ticket-list', name: 'ticket.ticketListing',  component: ticketListing },
				{ path: '/ticket-view',  name: 'ticket.ticketView', props : true, component: ticketView },
				//-------------------------deposit-----------------------------------------------
				{ path: '/create-deposit',  name: 'deposit.createDeposit', props : true, component: createDeposit },
				{ path: '/deposit-list',  name: 'deposit.depositListing',  component: depositListing },
				{ path: '/deposit-transaction',  name: 'deposit.depositTransaction',  component: depositTransaction },
				{ path: '/deposit-view',  name: 'deposit.depositView', props : true, component: depositView },
				//-------------------------wallet-----------------------------------------------
				{ path: '/wallet-list',  name: 'wallet.walletListing',  component: walletListing },			
				//-------------------------admin------------------------------------------------
				{ path: '/search', name: 'shared.search',  component: search },
				//-------------------------bonus-----------------------------------------------
				{ path: '/create-bonus',  name: 'bonus.createBonus',  component: createBonus },
				{ path: '/bonus-list',  name: 'bonus.bonusListing',  component: bonusListing },
				{ path: '/bonus-view',  name: 'bonus.bonusView', props : true, component: bonusView },
				//-------------------------commission-----------------------------------------------
				{ path: '/commission-list',  name: 'commission.commissionListing',  component: commissionListing },
				{ path: '/commission-view',  name: 'commission.commissionView', props : true, component: commissionView },
				{ path: '/create-commission',  name: 'commission.createCommission',  component: createCommission },
				//-------------------------withdrawal--------------------------------------------
				{ path: '/create-withdrawal', name: 'withdrawal.createWithdrawal',  component: createWithdrawal },
				{ path: '/withdrawal-list',  name: 'withdrawal.withdrawalListing', component: withdrawalListing },
				{ path: '/withdrawal-view',  name: 'withdrawal.withdrawalView',  props : true, component: withdrawalView },
				//-------------------------trading-account---------------------------------------
				{ path: '/create-trading',  name: 'trading.createTrading', component: createTrading },
				{ path: '/trading-list',  name: 'trading.tradingListing', component: tradingListing },
				{ path: '/trading-changestatus',  name: 'trading.tradingChangeStatus', component: tradingChangeStatus },
				{ path: '/trading-view',  name: 'trading.tradingView',  props : true, component: tradingView },
				//-------------------------admin-------------------------------------------------
				{ path: '/dashboard',   name: 'admin.adminDashboard',  component: adminDashboard },
				{ path: '/notification-list', name: 'admin.notificationListing',  component: notificationListing },
				//-------------------------ContactDetails------------------------------------------------
				{ path: '/contact-us', name: 'admin.ContactDetails',  component: contactDetails },
			]
		},   
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js